import React, { memo, useEffect, useState, useMemo, useRef } from 'react'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'

import useMediaQuery from '@material-ui/core/useMediaQuery'
import getConfig from 'next/config'

import useContainerDimensions from '../../utils/hooks/useContainerDimensions'

const { publicRuntimeConfig } = getConfig()
const { externalBannerApi: EXTERNAL_BANNER_API, enableBanner: ENABLE_BANNER } =
  publicRuntimeConfig

const MySkeleton = ({ isMobile }) => {
  const dimention = useMemo(() => {
    return { width: isMobile ? '100%' : '100%', heigth: 180 }
  }, isMobile)

  const { width, heigth } = dimention

  return <Skeleton width={width} height={heigth} />
}

const EB_Checkprice = () => {
  const ref = useRef(null)

  const isMobile = useMediaQuery('(max-width:820px)', { noSsr: true })
  const [isSuccess, setIsSuccess] = useState(false)
  // Whether the API actually returned a banner to render. When it doesn't
  // (no active campaign for this env), the slot must take NO vertical space,
  // otherwise its empty box + marginBottom leaves an uneven gap between the
  // courier result cards.
  const [hasBanner, setHasBanner] = useState(false)

  const { width } = useContainerDimensions(ref)

  useEffect(() => {
    const fethBanner = () => {
      const size = isMobile ? 'mobile' : 'desktop'
      const url = `${EXTERNAL_BANNER_API}/api/banner?device=${size}&position_page=EB_CHECKPRICE`

      fetch(url)
        .then((response) => response.json())
        .then((res) => {
          const ok = !!(res && res.js)
          setHasBanner(() => ok)
          setIsSuccess(() => true)
          if (ok) {
            console.info(`res`, res)
            eval(res.js)('el-checkprice')
          }
        })
        .catch((err) => {
          setHasBanner(() => false)
          setIsSuccess(() => true)
          console.error(`EB_Checkprice err`, err.message, err)
        })
    }
    if (ENABLE_BANNER) {
      fethBanner(isMobile)
    }
  }, [isMobile, width])

  // Disabled, or the fetch finished with no banner -> render nothing so the
  // slot collapses and the result rows keep an even rhythm.
  if (!ENABLE_BANNER) return null
  if (isSuccess && !hasBanner) return null

  return (
    <Box
      width="100%"
      ref={ref}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      // marginTop={2}
      marginBottom={4}
    >
      {/* must stay mounted before eval() injects into it by id */}
      <Box id="el-checkprice" />
      {!isSuccess && <MySkeleton isMobile={isMobile} />}
    </Box>
  )
}

export default memo(EB_Checkprice)
